module.exports = __webpack_public_path__ + "img/o2o04.62625df0.png";